import React from "react";

import PropTypes from "prop-types";

import { Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";

import CategoryCheckboxList from "./CategoryCheckboxList";

import LayersIcon from "@mui/icons-material/Layers";
import ContextIcon from "../icons/ContextIcon";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function DrawerTabsContainer() {
  const [tabValue, setTabValue] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <Box
      sx={{
        maxHeight: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ height: "80px" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="map-tabs"
          selectionFollowsFocus
          variant="fullWidth"
        >
          <Tab
            icon={<LayersIcon fontSize="large" />}
            disableRipple
            label={"Planning Layers"}
            aria-label="planning layers"
          />
          <Tab
            icon={<ContextIcon fontSize="large" />}
            disableRipple
            label={"Context Layers"}
            aria-label="context"
          />
        </Tabs>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          height: "100%",
          maxHeight: "100%",
          mb: isMobile ? 2 : 5,
        }}
      >
        <TabPanel value={tabValue} index={0}>
          <CategoryCheckboxList category="planning" />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <CategoryCheckboxList category="context" />
        </TabPanel>
      </Box>
    </Box>
  );
}

export default DrawerTabsContainer;
